import { Alert, Box, Grid, Snackbar, styled, TextField } from '@mui/material'
import React, { useState } from 'react'
import { Btn1, Btn2, MyTextField } from '../StyledComponents';
import emailjs from 'emailjs-com';


function Form() {

  
  const [openStatus, setOpenStatus] = React.useState(false);
  const [statusMessage, setStatusMessage] = React.useState("");
  const [message, setMessage] = React.useState("Submit");


  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject:'',
    message:''
  });

  const [errors, setErrors] = useState({
    name: false,
    email: false,
    phone: false,
    subject: false,
  });

  const handleChange = (event) => {
    setErrors({})
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    
    const newErrors = {};


    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = 'This field is required';
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setMessage("Sending...");
      emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID, 
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID, 
        {...formData,reply_to:"kadapasharief2854@gmail.com"},
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then((response) => {
        // console.log('SUCCESS!', response.status, response.text);
      
        if(response.status==200)
        {
          setOpenStatus(true);
          setMessage("Done");
          setTimeout(()=>
          {
            setMessage("Submit");
          },5000)
          setStatusMessage("Thanks for submitting your details! I look forward to connecting with you soon.")
        }
        else{
          setOpenStatus(true);
          setStatusMessage("It seems there was an issue. Please try again, or feel free to email me directly.")
        }
        
      })
      .catch((err) => {
        setOpenStatus(true);
        setStatusMessage("It seems there was an issue. Please try again, or feel free to email me directly.")
      });

      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message:''
      });
      setErrors({});
    }
  };

  const closeStatus = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenStatus(false);
  };





  return (
    <Box>
        <form  onSubmit={handleSubmit}>
           <Grid container columnSpacing={3} rowSpacing={3}>
              <Grid item xs={12} sm={6} md={6} data-aos="fade-up" data-aos-duration="2000">
                  <MyTextField 
                    name="name"
                    label="Your Name" 
                    error={!!errors.name}
                    helperText={errors.name}
                    type='text' 
                    fullWidth  
                    margin="dense"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} data-aos="fade-up" data-aos-duration="2000">
                  <MyTextField 
                    name="email"
                    label="Your Email" 
                    type='email' 
                    fullWidth  
                    margin="dense"
                    error={!!errors.email}
                    helperText={errors.email}
                    value={formData.email}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} data-aos="fade-up" data-aos-duration="2000">
                  <MyTextField
                    name="phone" 
                    label="Your Phone" 
                    type='tel' 
                    fullWidth  
                    error={!!errors.phone}
                    helperText={errors.phone}
                    margin="dense"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} data-aos="fade-up" data-aos-duration="2000">
                  <MyTextField 
                    name="subject"
                    label="Subject" 
                    fullWidth  
                    margin="dense"
                    error={!!errors.subject}
                    helperText={errors.subject}
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} sx={{'& .MuiInputBase-input': {color: 'text.primary',},}} data-aos="fade-up" data-aos-duration="2000">
                  <MyTextField 
                    label="Write your message here..." 
                    name="message"
                    fullWidth 
                    multiline 
                    rows={5}  
                    margin="dense"
                    value={formData.message}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Btn2
                  data-aos="fade-up" data-aos-duration="2000"
                  type='submit' 
                    sx={{
                      fontSize:{xs:"0.8rem",sm:"1rem",md:"1.08rem"},
                      padding:{xs:"5px 20px",sm:"5px 25px",md:"5px 35px"}, 

                      '&:after':{
                          height:"100%"
                      },
                      '&:hover:after':{
                          height:"0%"
                      }
                    }}
                     
                  >
                    {message}
                  </Btn2>
                  <Snackbar open={openStatus} autoHideDuration={6000} onClose={closeStatus}>
                    <Alert
                        onClose={closeStatus}
                        severity="success"
                        variant="filled"
                        sx={{ width: '100%'}}
                    >
                        {statusMessage}
                    </Alert>
                </Snackbar>
                  
              </Grid>
           </Grid>
           
        </form>
        
    </Box>
  )
}

export default Form
